module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.0@core-js/library/modules/_add-to-unscopables.js
// module id = 417
// module chunks = 0 1